/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="85.15"
        height="94.33"
        viewBox="0 0 85.15 94.33"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M18.52 22.84a1.25 1.25 0 0 1 .12 2.49H11.4A8.89 8.89 0 0 0 2.5 34v24.25a1.38 1.38 0 0 0 1.27 1.42h5.36a1.27 1.27 0 0 1 1.23 1.28 1.25 1.25 0 0 1-1.1 1.21H3.9a3.89 3.89 0 0 1-3.89-3.67V34.23a11.41 11.41 0 0 1 11.11-11.39ZM29.17 82.95v11.39h-2.5V82.95Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M35.77 49.67a1.27 1.27 0 0 1 1.22 1.12v7.63a3.87 3.87 0 0 1-3.69 3.68h-4.13v20.79a1.25 1.25 0 0 1-1.12 1.25h-.13a1.23 1.23 0 0 1-1.24-1.12V60.89a1.27 1.27 0 0 1 1.09-1.22h5.35a1.39 1.39 0 0 0 1.39-1.26v-7.38a1.24 1.24 0 0 1 1.13-1.23ZM25.63 22.84A11.39 11.39 0 0 1 37 33.93v1.92a1.24 1.24 0 0 1-1.28 1.21 1.26 1.26 0 0 1-1.21-1.09v-1.74a8.89 8.89 0 0 0-8.63-8.89h-7.36a1.25 1.25 0 0 1-1.31-1.19 1.24 1.24 0 0 1 1.18-1.31Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M18.52 82.95v11.39"/>
        <path
          fill="#fff"
          d="M19.77 82.95v11.39h-2.5V82.95Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M18.52 60.84v22.09"/>
        <path
          fill="#fff"
          d="M18.52 59.59a1.24 1.24 0 0 1 1.25 1.08V82.9a1.24 1.24 0 0 1-1.23 1.25 1.27 1.27 0 0 1-1.25-1.12V60.84a1.25 1.25 0 0 1 1.25-1.26Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M9.12 82.95v11.39"/>
        <path
          fill="#fff"
          d="M10.37 82.95v11.39h-2.5V82.95Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M9.12 39.5v43.45"/>
        <path
          fill="#fff"
          d="M9.12 38.25a1.27 1.27 0 0 1 1.25 1.13v43.57a1.24 1.24 0 0 1-1.28 1.21 1.26 1.26 0 0 1-1.21-1.09V39.5a1.26 1.26 0 0 1 1.24-1.25ZM18.52 0a9.83 9.83 0 1 0 9.83 9.84A9.84 9.84 0 0 0 18.52 0Zm0 2.5a7.33 7.33 0 1 1-7.32 7.34 7.34 7.34 0 0 1 7.32-7.34Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M22.9 35.46a1.25 1.25 0 0 1 1.89 1.63l-.09.09-6.07 6.35 5.94 6.22a1.24 1.24 0 0 1 .06 1.67l-.1.1a1.24 1.24 0 0 1-1.66 0l-.1-.09L16 44.36a1.27 1.27 0 0 1-.09-1.63l.09-.11Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M73.77 22.84a11.39 11.39 0 0 1 11.4 11.09v24.52a3.87 3.87 0 0 1-3.69 3.68h-5.46a1.25 1.25 0 0 1-.12-2.49h5.35a1.38 1.38 0 0 0 1.39-1.26v-23.9a.43.43 0 0 1 0-.16v-.09h-.09a8.88 8.88 0 0 0-8.53-8.89h-7.38a1.25 1.25 0 0 1-1.31-1.19 1.24 1.24 0 0 1 1.18-1.31h7.26ZM58.48 82.95v11.39h-2.5V82.95Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M49.37 49.67a1.25 1.25 0 0 1 1.24 1.12v7.43a1.38 1.38 0 0 0 1.26 1.45h5.36a1.26 1.26 0 0 1 1.24 1.12v22.17a1.23 1.23 0 0 1-1.23 1.25 1.26 1.26 0 0 1-1.22-1.11V62.14h-4a3.89 3.89 0 0 1-3.88-3.69V51a1.25 1.25 0 0 1 1.2-1.29ZM66.64 22.84a1.25 1.25 0 0 1 1.23 1.27 1.27 1.27 0 0 1-1.1 1.22h-7.25A8.88 8.88 0 0 0 50.63 34v1.88a1.25 1.25 0 0 1-2.49.12v-1.77a11.4 11.4 0 0 1 11.09-11.39Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M66.64 82.95v11.39"/>
        <path
          fill="#fff"
          d="M67.89 82.95v11.39h-2.5V82.95Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M66.64 60.84v22.09"/>
        <path
          fill="#fff"
          d="M66.64 59.59a1.24 1.24 0 0 1 1.24 1.12v22.23a1.24 1.24 0 0 1-1.23 1.25 1.27 1.27 0 0 1-1.25-1.12V60.84a1.25 1.25 0 0 1 1.25-1.26Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M76.03 82.95v11.39"/><path
          fill="#fff"
          d="M77.28 82.95v11.39h-2.51V82.95Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M76.03 39.5v43.45"/><path
          fill="#fff"
          d="M76 38.25a1.27 1.27 0 0 1 1.25 1.13v43.57a1.24 1.24 0 0 1-1.28 1.21 1.26 1.26 0 0 1-1.2-1.09V39.5A1.26 1.26 0 0 1 76 38.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M66.63 0a9.83 9.83 0 1 0 9.83 9.84A9.84 9.84 0 0 0 66.63 0Zm0 2.5a7.33 7.33 0 1 1-7.32 7.34 7.34 7.34 0 0 1 7.32-7.34Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M65.18 42.28a1.27 1.27 0 0 1 1.32 1.19 1.25 1.25 0 0 1-1.19 1.31H18.47a1.24 1.24 0 0 1-1.22-1.27 1.26 1.26 0 0 1 1.09-1.22h46.84Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M60.49 35.42a1.27 1.27 0 0 1 1.67-.06l.1.1 6.9 7.21a1.25 1.25 0 0 1 .09 1.62l-.09.12-6.77 7.07a1.25 1.25 0 0 1-1.76.05 1.26 1.26 0 0 1-.14-1.68l.09-.1 5.94-6.22-6.07-6.35a1.25 1.25 0 0 1 0-1.66Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwoPeopleTwoWayArrowsIcon';

export default Icon;
